import styled from "styled-components";
import { V3Button } from "../Button";

export const V3EmptyStateBtn = styled(V3Button)`
    height: 48px;
    padding: 20px;
`;
